import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { AxiosResponse } from 'axios';

import { authorizedAxiosInstance } from '@/clients';

export const useBilling = () => {
    const [loading, setLoading] = useState(false);

    const [activeSeats, setActiveSeats] = useState<number>(0);
    const [totalSeats, setTotalSeats] = useState<number>(2);

    const handleGetBillingInformation = async () => {
        try {
            await authorizedAxiosInstance.get('/api/billing').then((res: AxiosResponse) => {
                if (res?.status === 200) {
                    setActiveSeats(res?.data?.activeMembers);

                    setTotalSeats(res?.data?.totalSeats);
                }
            });
        } catch (error) {
            captureException(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleGetBillingInformation();

        setLoading(false);
    }, []);

    const progressMeterValue = loading && activeSeats === 0 ? 0 : Number(activeSeats / totalSeats) * 100;

    return {
        billingInformationLoading: loading,
        activeWorkspaceSeats: activeSeats,
        totalWorkspaceSeats: totalSeats,
        progressMeterValue,
    };
};
